export default {
	sales: 'مبيعات',
	'cashbox-name': 'اسم الصندوق',
	'name-of-the-financial-account': 'اسم الحساب المالي'
}